import { render, staticRenderFns } from "./UserProfileSidebar.vue?vue&type=template&id=b65ab9a0&scoped=true"
import script from "./UserProfileSidebar.vue?vue&type=script&lang=js"
export * from "./UserProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserProfileSidebar.vue?vue&type=style&index=0&id=b65ab9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ab9a0",
  null
  
)

export default component.exports